import { SET_ALERTS, REPLACE_ALERT } from './actiontypes';
import { getAlerts, muteAlert } from '../../api/Api';

const sendData = (type, data) => ({
  type,
  data,
});

export const getAlertsAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getAlerts(jwt).then((data) => dispatch(sendData(SET_ALERTS, data)));
};

export const muteAlertAction = (key, timestamp, mute) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return muteAlert(key, timestamp, mute, jwt).then((data) =>
    dispatch(sendData(REPLACE_ALERT, data))
  );
};
